import { Component } from 'react';

class DateUtilities extends Component {
    getTimestamp = (day, month, year) => {
        if (day && month && year) {
          const date = new Date(`${year}-${month}-${day}`);
          return date.getTime();
        }
        return 0;
      }
    
}

const dateUtilities = new DateUtilities()
export default dateUtilities;